import { Heading, Page } from '../../components';
import { Box, Typography } from '@mui/material';
import { Button, TextInput, Select, Price, Label, MultiImage } from '../../components/FormV2/components';
import { useYupResolver } from '../../hooks';
import { useForm } from 'react-hook-form';
import { plotSchema } from './plotSchema';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import plotService from '../../lib/signtouch/plotsService';
import { setPlots } from '../../store/actions/plots';
import addPending from '../../utils/addPending';
import removePending from '../../utils/removePending';
import { addError, addNotification } from '../../utils';
import { LabeledToggle } from '../../components/Toggle/LabeledToggle';
import SwitchInput from 'components/Form/components/Switch';
 
export const EditPlotPage = () => {

  const { developmentId, plotId } = useParams();
  const properties = useSelector((state) => state.properties);
  const { currentDevelopment } = useSelector((state) => state.general);
  const PhasesAsOptions = currentDevelopment.phases.map(phase => ({
    label: `${phase.name}${phase.default ? ' (default)' : ''}`,
    value: phase.id
  }));
  const { map } = properties.branding;
  const plot = useSelector(state => state.plots.find(plot => `${plot.id}` === plotId));
  const [isShowHome, setIsShowHome] = useState(plot?.isShowHome || false)
  const [isFeaturedPlot, setIsFeaturedPlot] = useState(plot?.isFeaturedPlot ||false)
  const houseTypes = useSelector(state => state.houseTypes);
  const houseTypesAsOptions = houseTypes.map(houseType => ({
    label: houseType.name,
    value: houseType.id
  }));
  const [saving, setSaving] = useState(false);
  const [isAffordable, setIsAffordable] = useState(plot?.isAffordable ?? false);
  let statusTypesAsOptions = [];
  Object.keys(map)
    .filter(key => !key.endsWith("label") && !key.endsWith("category"))
    .reduce((obj, key) => {
      obj = { label: map[key + "label"], value: key };
      statusTypesAsOptions.push(obj);
    }, {});
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const resolver = useYupResolver(plotSchema);
  const { control, handleSubmit } = useForm({
    resolver,
  });


  const onSubmit = async data => {
    setSaving(true);
    const pendingToast = addPending('updating plot');

    try {
      await plotService.updatePlot({
        ...plot,
        ...data,
        isAffordable,
        isShowHome,
        isFeaturedPlot
      });
      await dispatch(setPlots());
      removePending(pendingToast);
      addNotification('Successfully updated plot');
      setSaving(false);
      navigate(`/developments/${developmentId}/plots`)
    } catch (error) {
      removePending(pendingToast);
      addError(error.message || 'Unable to update plot');
      setSaving(false);
    }
  };

  return (
    <Page>
      <Heading label={`Edit Plot`} />

      <Box
        sx={{
          maxWidth: '600px', p: 4, backgroundColor: 'white', borderRadius: 2
        }}
      >
        <Box as='div' display='flex' justifyContent='space-between' alignItems='center'>
          <Heading label={`Edit Plot`} headingStyles={{ margin: 0 }}/>
          <Box as='div' display='flex' alignItems='center'>
            <Label styles={{ marginRight: '10px' }}>Affordable</Label>
            <LabeledToggle
              name='isAffordable'
              initialValue={isAffordable}
              onChange={(value) => setIsAffordable(value)}
            />
          </Box>
        </Box>
        <Typography sx={{ mt: 1, mb: 2 }}>
          Edit a plot, you can plot it on the map later.
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{
              width: '50%', display: 'flex', flexDirection: 'column', gap: 1
            }}>
              <TextInput
                full
                name='number'
                label='PLOT NUMBER'
                control={control}
                defaultValue={plot.number}
              />
              <Price
                full
                name='price'
                label='PRICE'
                control={control}
                defaultValue={plot.price}
              />
              <Select
                full
                name='status'
                label='STATUS'
                control={control}
                options={statusTypesAsOptions}
                defaultValue={plot.status}
              />
              <Select
                full
                name='houseType'
                label='HOUSE TYPE'
                control={control}
                options={houseTypesAsOptions}
                defaultValue={plot.houseType}
              />
              <LabeledToggle
                label="Featured Plot"
                initialValue={plot?.isFeaturedPlot}
                onChange={(e) =>  setIsFeaturedPlot(e)}
              />
              <LabeledToggle
                label="Show Home"
                initialValue={plot?.isShowHome}
                onChange={(e) => setIsShowHome(e)}
              />
              <MultiImage
                name={'multimedia'}
                label={'Upload images'}
                control={control}
                defaultValue={plot.multimedia || []}
              />
              {currentDevelopment?.phaseEnabled &&
              <Select
                full
                name='phase'
                label='Phase'
                control={control}
                defaultValue={plot.phase}
                options={[{label: 'None', value: null}, ...PhasesAsOptions]}
                />
              }
            </Box>
            <Button type='submit' disabled={saving}>{saving ? 'Saving...' : 'Save'}</Button>
          </Box>
        </form>
      </Box>
    </Page>
  );
};
